import React, { useState, useEffect, useRef } from "react";
import { useSwipeable } from 'react-swipeable';
import NavBar from "../partials/header/AuthNavBar";
import image from "../assets/images/accompagnement-personalise.webp";
import tunisie from "../assets/images/tun2.webp";
import france from "../assets/images/fr2.webp";
import belgique from "../assets/images/belgique.webp";
import espagne from "../assets/images/sp2.webp";
import canada from "../assets/images/can2.webp";
// import modify from "../assets/images/nos-pack.webp";
import valid from "../assets/images/valid2.webp";
import arrow from "../assets/images/arrow.webp";
import subs from "../assets/images/subs.webp";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import ong from "../assets/images/pngwing 2.webp";
import uni from "../assets/images/uni.webp";
import grad from "../assets/images/grad.webp";
import right from "../assets/images/right.svg";
import left from "../assets/images/small-left.svg";
import jamila from "../assets/images/jamila.webp";
import israa from "../assets/images/israa.webp";
import eya from "../assets/images/mreai.webp";
import moaataz from "../assets/images/moaataz.webp";
import saada from "../assets/images/saada.webp";
import fourah from "../assets/images/fourah.webp";
import skye from "../assets/images/skye.webp";
import straw from "../assets/images/straw.webp";
import laila from "../assets/images/laila.webp";
import nav from "../assets/images/Nav.webp";
import plays from "../assets/images/plays.webp";
import elips from "../assets/images/elips.webp";
import Footer from "../partials/footer/Footer";
import smartphone from "../assets/images/smartphone.webp";
import vid from "../assets/Final3.webm";
import "../assets/styles/landingPage.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet";
import GoogleReviewsWidget from "../components/GoogleReviewsWidget";
import CountriesCarousel from "../components/CountriesCarousel";
import { Check, BookOpen, Home, Crown } from "lucide-react"
import { useNavigate } from 'react-router-dom';
import AnissaImage from "../assets/images/AnissaImage.webp";
import KaisImage from "../assets/images/KaisImage.webp";
import NourImage from "../assets/images/NourImage.webp";
import DhiaImage from "../assets/images/DhiaImage.webp";



const LanddingPage = () => {

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const teamMembers = [
    {
      id: 'team-member-1',
      role: t('service.role_team_member1'),
      name: 'Anissa Najjar',
      description: t('service.attraction_phrase1'),
      image: AnissaImage,
      imageAlt: 'Portrait de Anissa Najjar'
    },
    {
      id: 'team-member-2',
      role: t('service.role_team_member2'),
      name: 'Kais Dridi',
      description: t('service.attraction_phrase2'),
      image: KaisImage,
      imageAlt: 'Portrait de Kais Dridi'
    },
    {
      id: 'team-member-3',
      role: t('service.role_team_member3'),
      name: 'Nour ElHouda Bacha',
      description: t('service.attraction_phrase3'),
      image: NourImage,
      imageAlt: 'Portrait de Nour ElHouda Bacha'
    },
        {
      id: 'team-member-4',
      role: "graphic designer",
      name: 'Dhia Daoud',
      description: t('service.attraction_phrase4'),
      image: DhiaImage,
      imageAlt: 'Portrait de Dhia Daoud'
    },
  ];
  

  const elements=[
    <div className="row px-3">
                  <div className="col-12 ">
                    <div className="py-3">
                      <p className="service-destination-text-loc">{t('pack1')}</p>
                    </div>
                    <ul className="ul-list-border-green p-0 pe-4">
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                        {t('service_1')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                        {t('service_2')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                        {t('service_3')}
                      </li>
                 
                    </ul>
                  </div>


                </div>
,
<div className="row px-3">
                  <div className="col-12 " style={{maxWidth:"180px",position:"relative"}}>
                    <div className="py-3">
                      <p className="service-destination-text-loc2">{t('pack2')}</p>
                    </div>
                    <ul className="ul-list-border-green p-0 pe-4">
                      <li className="service-list-drop-down2 ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                        {t('service_4')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                      {t('service_5')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                      {t('service_6')}
                      </li>
                     

                    </ul>
                  </div>

                </div>
,

<div className="row px-3">
                  <div className="col-12 ">
                    <div className="py-3">
                      <p className="service-destination-text-loc">{t('pack3')}</p>
                    </div>
                    <ul className="ul-list-border-green p-0 pe-4">
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                        {t('service_7')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                      {t('service_8')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                      {t('service_9')}
                      </li>
                     

                    </ul>
                  </div>

                </div>
   
  ]; 
  const [index, setIndex] = useState(0);
  const cardFeedRef = useRef();
  const cardFeedReffd = useRef();
  const intervalRef = useRef();

  const isMobile = useMediaQuery({ maxWidth: 992 });

 


  function moveSrollNext() {
    console.log(cardFeedReffd);
    intervalRef.current = setInterval(() => {
      cardFeedReffd.current.scrollLeft =cardFeedReffd.current.scrollLeft+ 5;

    }, 10);
  }
  function moveSrollPrev() {
    intervalRef.current = setInterval(() => {
      cardFeedReffd.current.scrollLeft =cardFeedReffd.current.scrollLeft- 5;

    }, 10);
  }

  const handleSwipe = (direction) => {
    if (direction === 'left') {
      setIndex((prevIndex) => (prevIndex === 0 ? elements.length - 1 : prevIndex - 1));
    } else if (direction === 'right') {
      setIndex((prevIndex) => (prevIndex === elements.length - 1 ? 0 : prevIndex + 1));
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => handleSwipe('left'),
    onSwipedRight: () => handleSwipe('right')
  });

  const handleNext = () => {
    setIndex((prevIndex) => (prevIndex === elements.length - 1 ? 0 : prevIndex + 1));
  };

  const handlePrev = () => {
    setIndex((prevIndex) => (prevIndex === 0 ? elements.length - 1 : prevIndex - 1));
  };

  const numberRef1 = useRef(null);
  const numberRef2 = useRef(null);

  useEffect(() => {
    const animateValue = (element, start, end, duration) => {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        element.innerHTML = Math.floor(progress * (end - start) + start) + "+";
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const endValue = parseInt(element.getAttribute('data-value'), 10);
          animateValue(element, 0, endValue, 2000); 
          observer.unobserve(element); 
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 1.0,
    });

    if (numberRef1.current) observer.observe(numberRef1.current);
    if (numberRef2.current) observer.observe(numberRef2.current);

    
    return () => {
      if (numberRef1.current) observer.unobserve(numberRef1.current);
      if (numberRef2.current) observer.unobserve(numberRef2.current);
    };
  }, []);
  const stopCounter = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  useEffect(() => {
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => stopCounter(); 
  }, []);
  


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Accueil | Créez votre succès | Success Study</title>
        <meta name="description" content="Solution Digitale,prestataire de services d’accompagnement et orientation académique, vise à optimiser le parcours universitaire et professionnel et à soutenir les jeunes étudiants." />
      </Helmet>
      <NavBar />
      <div className={isMobile?"main-section-bar-video-mob": "main-section-bar-video"}>
        <video
          style={{ width: "100%" }}
          className="elementor-video"
          src={vid}
          autoPlay={true}
          loop={true}
          muted="muted"
          playsinline=""
          controlslist="nodownload"
        ></video>
      </div>
      <div style={{ margin: isMobile ? "5rem 0 6rem 0" : "13rem 0 16rem 0" }}>
        <div className="custom-container">
          <div className="row" style={{ position: "relative" }}>
            <div className="pos-elips-image-bg">
              <img src={elips} alt="elips" style={{ width: "100%", height: "100%" }} />
            </div>
            <div className="col-12 col-lg-6">
              <div style={{ marginLeft: "6rem",marginTop:"30px" }}>
                <img src={image} alt="" style={{ width: "100%",maxWidth: "540px",objectFit: "cover" , height: "500px" ,borderRadius:"8px"}} />
              </div>
            </div>
            <div className="col-12 col-lg-6  py-5">
              <div className="landing-page-success">
                <h1 className="landing-page-success-text">{t("title_first")}</h1>
              </div>
              <div className="landing-describe-sucess my-5">
                <p className="landing-describe-sucess-text">
                  {t('first_title')}

                </p>
              </div>
              <div className="width-button-landinga-page my-3">
                <Link to="/profile" className="width-btn-landinga-page">
                  {t('showmore')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ margin: isMobile ? "15% 0 7% 0" : "10% 0 5% 0", position: "relative" }}>
        <div className="pos-right-fles-txt"></div>
        <div className="custom-container">
          <div className="mt-5">
            <h1 className="porps-about-company-des">
              {t('prince')}
            </h1>
            <p className="porps-about-company-des-title" style={{marginLeft:"20px"}}>
              {t('princ_desc')}
            </p>
          </div>

          <CountriesCarousel />
        </div>
      </div>
      <div style={{ margin: "19rem 0 15 0" }}>
        <div className="d-lg-block d-none"
          style={{
            width: "100%",
            height: "400px",
            position: "relative",
            margin: "8rem 0",
          }}
        >
          {/* <div className="img-section-box-landing">
            <img src={modify} style={{ width: "100%", height: "auto" }} alt="service image container"/>
          </div> */}

          <div className="card-pos-about-landing">
            <div className="border-green-supp-landing" style={{ position: "relative", top: '0px' }}>
              <div className="my-5 px-3" style={{ position: "relative" }}>
                <div className="pricing-section-header">
                  <h1 className="pricing-section-main-title">
                    {t("service.Titre_pack_section1")}<br />
                    <span style={{ color: '#FFB703', fontWeight: 400 }}>{t("service.Titre_pack_section2")}</span>
                  </h1>
                  <p className="pricing-section-subtitle">
                    {t("service.Titre_pack_section3")}
                  </p>
                </div>

                {/* <div className="text-post-underline"></div> */}
              </div>
              <div className="pricing-section-main-wrapper">
      <div className="pricing-cards-container-row">
        {/* First Card - Admission */}
        <div className="pricing-card-admission-wrapper">
          <div className="pricing-card-icon-container-admission">
            <BookOpen className="pricing-card-icon-admission" />
          </div>
          <div className="pricing-card-content-admission">
            <h3 className="pricing-card-title-admission">{t("pack1")}</h3>
            <p className="pricing-card-description-admission">{t("service.cta_pack_admission")
}</p>
            <div className="pricing-card-features-admission">
              <p className="pricing-card-features-label-admission">Inclure:</p>
              <ul className="pricing-features-list-admission">
                <li className="pricing-feature-item-admission">
                  <Check className="pricing-feature-check-icon-admission" />
                  <span className="pricing-feature-text-admission">{t("service_1")}</span>
                </li>
                <li className="pricing-feature-item-admission">
                  <Check className="pricing-feature-check-icon-admission" />
                  <span className="pricing-feature-text-admission">{t("service_2")}</span>
                </li>
                <li className="pricing-feature-item-admission">
                  <Check className="pricing-feature-check-icon-admission" />
                  <span className="pricing-feature-text-admission">{t("service_3")}</span>
                </li>
              </ul>
            </div>

            <button  className="pricing-card-button-admission" onClick={() => navigate('/sign-in')}>{t("service.cta_button_adm_log")}</button>
          </div>
        </div>

        {/* Second Card - Logement */}
        <div className="pricing-card-logement-wrapper">
          <div className="pricing-card-icon-container-logement">
            <Home className="pricing-card-icon-logement" />
          </div>

          <div className="pricing-card-content-logement">
            <h3 className="pricing-card-title-logement">{t("pack2")}</h3>
            <p className="pricing-card-description-logement">{t("service.cta_pack_logement")}</p>


            <div className="pricing-card-features-logement">
              <p className="pricing-card-features-label-logement">Inclure:</p>
              <ul className="pricing-features-list-logement">
                <li className="pricing-feature-item-logement">
                  <Check className="pricing-feature-check-icon-logement" />
                  <span className="pricing-feature-text-logement">{t("service_4")}</span>
                </li>
                <li className="pricing-feature-item-logement">
                  <Check className="pricing-feature-check-icon-logement" />
                  <span className="pricing-feature-text-logement">{t("service_5")}</span>
                </li>
                <li className="pricing-feature-item-logement">
                  <Check className="pricing-feature-check-icon-logement" />
                  <span className="pricing-feature-text-logement">{t("service_6")}</span>
                </li>
              </ul>
            </div>

            <button className="pricing-card-button-logement" onClick={() => navigate('/sign-in')}>{t("service.cta_button_adm_log")}</button>
          </div>
        </div>

        {/* Third Card - Complete (Premium) */}
        <div className="pricing-card-complete-wrapper">
          <div className="pricing-card-icon-container-complete">
            <Crown className="pricing-card-icon-complete" />
          </div>

          <div className="pricing-card-content-complete">
            <h3 className="pricing-card-title-complete">{t("pack3")}</h3>
            <p className="pricing-card-description-complete">{t("service.cta_pack_complete")}</p>


            <div className="pricing-card-features-complete">
              <p className="pricing-card-features-label-complete">Inclure:</p>
              <ul className="pricing-features-list-complete">
                <li className="pricing-feature-item-complete">
                  <Check className="pricing-feature-check-icon-complete" />
                  <span className="pricing-feature-text-complete">{t("service_7")}</span>
                </li>
                <li className="pricing-feature-item-complete">
                  <Check className="pricing-feature-check-icon-complete" />
                  <span className="pricing-feature-text-complete">{t("service_8")}</span>
                </li>
                <li className="pricing-feature-item-complete">
                  <Check className="pricing-feature-check-icon-complete" />
                  <span className="pricing-feature-text-complete">{t("service_9")}</span>
                </li>
              </ul>
            </div>

            <button className="pricing-card-button-complete" onClick={() => navigate('/sign-in')}>{t("service.cta_button_complete")}</button>
          </div>
        </div>
      </div>
    </div>

    
              {/* <div className="row" style={{width:"100%"}}>
                <div className="d-flex justify-content-center" style={{ height: "600px" }}>

                  <div style={{ position: "relative", left: "60px", width: "100%", overflow: "hidden" }}>
                    <img src={smartphone} style={{ width: "100%", height: "100%" }} alt="background" />
                    <div style={{ position: "absolute", top: "15%", left: "45%", transform: "translateX(-50%)", textAlign: "center" }}>
                      <div className="row px-3">
                        <div className="col-12 ">
                          <div className="py-3">
                            <p className="service-destination-text-loc">{t('pack1')}</p>
                          </div>
                          <ul className="ul-list-border-green p-0 pe-4">
                            <li className="service-list-drop-down ">
                              <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                              {t('service_1')}
                            </li>
                            <li className="service-list-drop-down ">
                              <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                              {t('service_2')}
                            </li>
                            <li className="service-list-drop-down ">
                              <div className="me-3">
                                <img src={valid} alt="valid" width={12} height={12} />
                              </div>
                              {t('service_3')}
                            </li>

                          </ul>
                        </div>
                      </div>              
                  </div>
              </div>

<div style={{ position: "relative", left: "30px", width: "100%", overflow: "hidden" }}>
  <img src={smartphone} style={{ width: "100%", height: "100%" }} alt="smartphone contains service"  />
  <div style={{ maxWidth:"230px", position: "absolute",  top: "15%", left: "43%", transform: "translateX(-50%)", textAlign: "center" }}>
  
  


  <div className="row px-3">
                  <div className="col-12 ">
                  <div className="py-3">
                      <p className="service-destination-text-loc">{t('pack2')}</p>
                    </div>
                    <ul className="ul-list-border-green p-0 pe-4">
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                          <img src={valid} alt="valid" width={12} height={12} />
                        </div>                        {t('service_4')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                          <img src={valid} alt="valid" width={12} height={12} />
                        </div>                      {t('service_5')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                          <img src={valid} alt="valid" width={12} height={12} />
                        </div>                      {t('service_6')}
                      </li>
                     

                    </ul>
                  </div>


                </div>




  </div>
</div>

<div style={{ marginRight: "70px", position: "relative", width: "100%", overflow: "hidden" }}>
  <img src={smartphone} style={{ width: "100%", height: "100%" }}  alt="smartphone contains service" />
  <div style={{ position: "absolute", top: "15%", left: "45%", transform: "translateX(-50%)", textAlign: "center" }}>

  <div className="row px-3">
                  <div className="col-12 ">
                  <div className="py-3">
                      <p className="service-destination-text-loc">{t('pack3')}</p>
                    </div>
                    <ul className="ul-list-border-green p-0 pe-4">
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                          <img src={valid} alt="valid" width={12} height={12} />
                        </div>                        {t('service_7')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                          <img src={valid} alt="valid" width={12} height={12} />
                        </div>                      {t('service_8')}
                      </li>
                      <li className="service-list-drop-down ">
                      <div className="me-3">
                          <img src={valid} alt="valid" width={12} height={12} />
                        </div>                      {t('service_9')}
                      </li>
                     

                    </ul>
                  </div>


                </div>

  </div>
</div>
</div>
</div>     */}         
              
                </div>
    <div className="team-section__container">
      <div className="team-section__inner-wrapper">
          <div className="pricing-section-header">
                  <h1 className="pricing-section-main-title">
                    {t("service.Titre_team_section1")}<br />
                    <span style={{ color: '#FFB703', fontWeight: 400 }}>{t("service.Titre_team_section2")}</span>
                  </h1>
                  <p className="pricing-section-subtitle">
                    {t("service.Titre_team_section3")}
                  </p>
          </div>
        
        <div className="team-section__members-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className={`team-section__member-card team-section__member-card--${member.id}`}>
              <div className="team-section__member-image-container">
                <img 
                  src={member.image} 
                  alt={member.imageAlt}
                  className="team-section__member-image"
                  loading="lazy"
                />
              </div>
              <p className="team-section__member-role">{member.role}</p>
              <h3 className="team-section__member-name">{member.name}</h3>
              <p className="team-section__member-description">{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
              </div> 


            </div>

            

            {/* Mobile Version - Modern Cards */}
<div className="d-block d-lg-none mobile-pricing-section-wrapper">
  <div className="d-flex justify-content-center">
    <div className="mobile-pricing-card-container">
      <div className="mobile-pricing-border-wrapper" style={{marginTop:"50px"}}>
        <div className="my-3 px-3" style={{ position: "relative" }}>
          <div className="pricing-section-header">
                  <h1 className="pricing-section-main-title">
                    {t("service.Titre_pack_section1")}<br />
                    <span style={{ color: '#FFB703', fontWeight: 400 }}>{t("service.Titre_pack_section2")}</span>
                  </h1>
                  <p className="pricing-section-subtitle">
                    {t("service.Titre_pack_section3")}
                  </p>
                </div>
          <div className="mobile-pricing-underline"></div>
        </div>

        <div className="row" style={{width:"100%"}}>
          <div className="d-flex justify-content-center align-items-center">
            
            {/* Previous Button */}
            <button 
              onClick={handlePrev} 
              className="mobile-pricing-nav-btn-prev"
              style={{ 
                border: 'none', 
                padding: '0', 
                width: '45px', 
                height: '45px',
                borderRadius:"50%",
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                marginRight: "10px",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15,18 9,12 15,6"></polyline>
              </svg>
            </button>

            {/* Card Container */}
            <div className="mobile-pricing-card-display" style={{ 
              position: "relative", 
              width: "280px", 
              height: "450px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              marginTop: "10px"
            }}>
              
              {/* Card 1 - Admission */}
              {index === 0 && (
                <div className="mobile-pricing-card-admission" style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#e9ecef",
                  padding: "24px",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center"
                }}>
                  <div className="mobile-pricing-icon-admission" style={{ marginBottom: "16px" }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                    </svg>
                  </div>
                  
                  <h3 className="mobile-pricing-title-admission" style={{
                    fontSize: "2.2rem",
                    fontWeight: "700",
                    color: "#212529",
                    marginBottom: "8px",
                    lineHeight: "1.2"
                  }}>
                    {t('pack1')}
                  </h3>
                  
                  <p className="mobile-pricing-desc-admission" style={{
                    color: "#6c757d",
                    fontSize: "1.5rem",
                    marginBottom: "16px",
                    lineHeight: "1.4"
                  }}>
                    {t("service.cta_pack_admission")}
                  </p>
                  
                  <div className="mobile-pricing-price-admission" style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    color: "#212529",
                    marginBottom: "16px"
                  }}>
      
                  </div>
                  
                  <div className="mobile-pricing-features-admission" style={{ flex: "1", textAlign: "left" }}>
                    <p style={{ fontWeight: "600", color: "#495057", marginBottom: "12px", fontSize: "1.5rem" }}>
                      Inclure:
                    </p>
                    <ul className="mobile-pricing-list-admission" style={{ listStyle: "none", padding: "0", margin: "0" }}>
                      <li className="mobile-pricing-item-admission" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#495057", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_1')}
                        </span>
                      </li>
                      <li className="mobile-pricing-item-admission" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#495057", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_2')}
                        </span>
                      </li>
                      <li className="mobile-pricing-item-admission" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#495057", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_3')}
                        </span>
                      </li>
                    </ul>
                  </div>
                  
                  <Link to="./sign-in" className="mobile-pricing-btn-admission" style={{
                    backgroundColor: "#21769A",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                    padding: "12px 20px",
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    cursor: "pointer",
                    width: "100%",
                    marginTop: "16px"
                  }}
                  >
                    {t("service.cta_button_adm_log")}
                    
                  </Link>
                </div>
              )}

              {/* Card 2 - Logement */}
              {index === 1 && (
                <div className="mobile-pricing-card-logement" style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#e9ecef",
                  padding: "24px",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center"
                }}>
                  <div className="mobile-pricing-icon-logement" style={{ marginBottom: "16px" }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2">
                      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9,22 9,12 15,12 15,22"></polyline>
                    </svg>
                  </div>
                  
                  <h3 className="mobile-pricing-title-logement" style={{
                    fontSize: "2.2rem",
                    fontWeight: "700",
                    color: "#212529",
                    marginBottom: "8px",
                    lineHeight: "1.2"
                  }}>
                    {t('pack2')}
                  </h3>
                  
                  <p className="mobile-pricing-desc-logement" style={{
                    color: "#6c757d",
                    fontSize: "1.5rem",
                    marginBottom: "16px",
                    lineHeight: "1.4"
                  }}>
                    {t("service.cta_pack_logement")}
                  </p>
                  
                  <div className="mobile-pricing-price-logement" style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    color: "#212529",
                    marginBottom: "16px"
                  }}>
                  </div>
                  
                  <div className="mobile-pricing-features-logement" style={{ flex: "1", textAlign: "left" }}>
                    <p style={{ fontWeight: "600", color: "#495057", marginBottom: "12px", fontSize: "1.5rem" }}>
                      Inclure:
                    </p>
                    <ul className="mobile-pricing-list-logement" style={{ listStyle: "none", padding: "0", margin: "0" }}>
                      <li className="mobile-pricing-item-logement" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#495057", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_4')}
                        </span>
                      </li>
                      <li className="mobile-pricing-item-logement" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#495057", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_5')}
                        </span>
                      </li>
                      <li className="mobile-pricing-item-logement" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#495057", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_6')}
                        </span>
                      </li>
                    </ul>
                  </div>
                  
                  <Link to="./sign-in" className="mobile-pricing-btn-logement" style={{
                    backgroundColor: "#21769A",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                    padding: "12px 20px",
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    cursor: "pointer",
                    width: "100%",
                    marginTop: "16px"
                  }}>
                    {t("service.cta_button_adm_log")}
                  </Link>
                </div>
              )}

              {/* Card 3 - Complete (Premium) */}
              {index === 2 && (
                <div className="mobile-pricing-card-complete" style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#f4d03f",
                  border: "2px solid #f1c40f",
                  padding: "24px",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center"
                }}>
                  <div className="mobile-pricing-icon-complete" style={{ marginBottom: "16px" }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#8b4513" strokeWidth="2">
                      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                      <path d="M4 22h16l-1-7H5"></path>
                      <path d="M8 9v-4a4 4 0 0 1 8 0v4"></path>
                    </svg>
                  </div>
                  
                  <h3 className="mobile-pricing-title-complete" style={{
                    fontSize: "2.2rem",
                    fontWeight: "700",
                    color: "#8b4513",
                    marginBottom: "8px",
                    lineHeight: "1.2"
                  }}>
                    {t('pack3')}
                  </h3>
                  
                  <p className="mobile-pricing-desc-complete" style={{
                    color: "#8b4513",
                    fontSize: "1.5rem",
                    marginBottom: "16px",
                    lineHeight: "1.4"
                  }}>
                    {t("service.cta_pack_complete")}
                  </p>
                  
                  <div className="mobile-pricing-price-complete" style={{
                    fontSize: "1.8rem",
                    fontWeight: "700",
                    color: "#8b4513",
                    marginBottom: "16px"
                  }}>
                  </div>
                  
                  <div className="mobile-pricing-features-complete" style={{ flex: "1", textAlign: "left" }}>
                    <p style={{ fontWeight: "600", color: "#8b4513", marginBottom: "12px", fontSize: "1.5rem" }}>
                      Inclure:
                    </p>
                    <ul className="mobile-pricing-list-complete" style={{ listStyle: "none", padding: "0", margin: "0" }}>
                      <li className="mobile-pricing-item-complete" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#27ae60" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#8b4513", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_7')}
                        </span>
                      </li>
                      <li className="mobile-pricing-item-complete" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#27ae60" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#8b4513", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_8')}
                        </span>
                      </li>
                      <li className="mobile-pricing-item-complete" style={{ 
                        display: "flex", 
                        alignItems: "flex-start", 
                        marginBottom: "8px", 
                        gap: "8px" 
                      }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#27ae60" strokeWidth="2" style={{ marginTop: "2px", flexShrink: "0" }}>
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                        <span style={{ color: "#8b4513", fontSize: "1.5rem", lineHeight: "1.4" }}>
                          {t('service_9')}
                        </span>
                      </li>
                    </ul>
                  </div>
                  
                  <Link to="./sign-in" className="mobile-pricing-btn-complete" style={{
                    backgroundColor: "#21769A",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                    padding: "12px 20px",
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    cursor: "pointer",
                    width: "100%",
                    marginTop: "16px"
                  }}>
                    {t("service.cta_button_complete")}
                  </Link>
                </div>
              )}
            </div>

            {/* Next Button */}
            <button 
              onClick={handleNext} 
              className="mobile-pricing-nav-btn-next"
              style={{ 
                border: 'none', 
                padding: '0', 
                width: '45px', 
                height: '45px',
                borderRadius:"50%",
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                marginLeft: "10px",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9,18 15,12 9,6"></polyline>
              </svg>
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="mobile-pricing-dots-wrapper" style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            marginTop: "20px"
          }}>
            {[0, 1, 2].map((dotIndex) => (
              <button
                key={dotIndex}
                onClick={() => setIndex(dotIndex)}
                className={`mobile-pricing-dot-${dotIndex}`}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: index === dotIndex ? "#5a9fd4" : "#dee2e6",
                  cursor: "pointer",
                  transition: "background-color 0.2s ease"
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <section className="team-section__container mobile-only-section">
      <div className="team-section__inner-wrapper">
                  <div className="pricing-section-header">
                  <h1 className="pricing-section-main-title">
                    {t("service.Titre_team_section1")}<br />
                    <span style={{ color: '#FFB703', fontWeight: 400 }}>{t("service.Titre_team_section2")}</span>
                  </h1>
                  <p className="pricing-section-subtitle">
                    {t("service.Titre_team_section3")}
                  </p>
                </div>
        
        <div className="team-section__members-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className={`team-section__member-card team-section__member-card--${member.id}`}>
              <div className="team-section__member-image-container">
                <img 
                  src={member.image} 
                  alt={member.imageAlt}
                  className="team-section__member-image"
                  loading="lazy"
                />
              </div>
              <p className="team-section__member-role">{member.role}</p>
              <h3 className="team-section__member-name">{member.name}</h3>
              <p className="team-section__member-description">{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
         
      
        {/* <div className="d-block d-lg-none img-sec-lan">
          <div className="d-flex justify-content-center">
            <div className="card-pos-about-landing-md">
              <div className="border-green-supp-landing" style={{marginTop:"100px"}}>
                <div className="my-3 px-3" style={{ position: "relative" }}>
                  <p className="our-service-lang"> Nos services</p>
                  <div className="text-post-underline"></div>
                </div>
                           
                <div className="row" style={{width:"100%"}}>
            

              <div className="d-flex justify-content-center">
              <button onClick={handlePrev} style={{ border: 'none', padding: '0', width: '50px', height: '150px',borderRadius:"10px" 
            , backgroundColor: 'rgba(255, 255, 255, 0.2)',
            filter: 'blur(1px)',
            marginTop:"150px"
            }}>
                    <img
            src={right}
            alt="rgiht"
            style={{ cursor: "pointer", transform: "rotate(180deg)" }}
            onMouseDown={moveSrollNext}
            onMouseUp={stopCounter}
            onMouseLeave={stopCounter}
          />
              
            </button>
<div style={{ position: "relative", width: "70%", overflow: "hidden" }}>
  <img src={smartphone} style={{ width: "100%", height: "100%" }} alt="smartphone contains service"  />
  <div style={{ position: "absolute", top: "10%",left:"45%", transform: "translateX(-50%)", textAlign: "center" }}>
 
  {elements[index]}


  </div>
 
</div>
<button onClick={handleNext} style={{ border: 'none', padding: '0', width: '50px', height: '150px',borderRadius:"10px"
  , backgroundColor: 'rgba(255, 255, 255, 0.2)',
  filter: 'blur(1px)', marginTop:"150px" }}>
    <img
            src={left}
            alt="rgiht"
            style={{ cursor: "pointer", transform: "rotate(180deg)" }}
            onMouseDown={moveSrollNext}
            onMouseUp={stopCounter}
            onMouseLeave={stopCounter}
          />
  </button>


</div>


</div>    
              
              
                </div>


              </div>
            </div>
      
        </div> */}
        </div>

      <div style={{ margin: isMobile ? "5rem 0" : "18rem 0" }}
      className={isMobile?"shaodw-box-container-mob": "shaodw-box-container"}>
        <div className="custom-container">
        <div className="row" style={{ position: "relative", top: isMobile ? "100px" : "700px" }}>
            
            <div
              className="col-12 col-lg-7 d-flex align-items-center py-5 "
              style={{ position: "relative"}}
            >
              <div className="pos-relative-landing">
                <img src={ong} alt="" style={{ width: "100%", height: "100%" }} />
              </div>
              <div className=" pss-5">
                <div className="landing-page-success ">
                  <h1 className="landing-page-success-text">
                    {" "}
                    <span className="landing-page-success-text color_main ">
                      {t('title_why')}
                    </span>{" "}
                    Success Study ?
                  </h1>
                  <h2 className="landing-page-success-text-desc-popings">
                    {t('sub_title_why')}
                  </h2>
                </div>
                <div className="landing-describe-sucess my-2">
                  <p className="landing-describe-sucess-text-popings" >
                    {t('des_title_why')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="psxs-5" style={{ margin: isMobile ? "5rem 0" : "13rem 0" }}>
        <div className="" style={{ width: "100%" ,position:"relative",top:"100px"}}>
          <div className="d-flex justify-content-center">
            <h1 className="text-success-to-say">
              Success Study{" "}
              <span className="text-success-to-say color_main ">
                {t('num_title')}
              </span>{" "}
            </h1>
          </div>
          <div className="d-lg-flex justify-content-between">
            <div className="card-user-yallow-lang-suc">
              <div className="d-lg-flex justify-content-center">
                <div className="box-fomation-do-success-study">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="me-3">
                      <img src={uni} alt="/" />
                    </div>
                    <p
              ref={numberRef1}  
              className="text-card-fomration-lan"
              style={{ margin: "0", marginTop: "10px" }}
              data-value="125"  
            >
              0+
            </p>
                  </div>
                  <div className="mt-3">
                    <p
                      className="text-card-fomration-lan-blue"
                      style={{ margin: "0" }}
                    >
                      {t('formation_chiff')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-user-yallow-lang-suc-yal">
              <div className="d-flex justify-content-center">
                <div className="box-fomation-do-success-study">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="me-3">
                      <img src={grad} alt="/" />
                    </div>
                    <p
              ref={numberRef2}
              className="text-card-fomration-lan"
              style={{ margin: "0", marginTop: "10px" }}
              data-value="300"  
            >
              0+
            </p>
                  </div>
                  <div className="mt-3">
                    <p
                      className="text-card-fomration-lan-blue"
                      style={{ margin: "0" }}
                    >
                      {t('student_text')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* testimonials */}
      <GoogleReviewsWidget />
      <div style={{ marginTop: isMobile ? "5rem" : "13rem", position: "relative" }}>
        <div className="footer-bar-section-landing-page">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100%" }}
          >
            <div className="mt-5" style={{ width: "85%", position: "relative", top: "100px" }}>
              <h1 className="text-footerl-line-header">
                {t('dream_1')}
                {t('dream_2')}
                <span className="text-footerl-line-header color_second">
                  Success Study:
                </span>{" "}
              </h1>
              <div className="my-5 d-flex justify-content-center">
                <p className="texta-underline-footer">
                  {t('sub_dream')}
                </p>
              </div>
              <div className="my-5 d-flex justify-content-center">
                <a href="/guide" className="btn-footer-special-ed">
                  <div className="">
                    <img src={plays} alt="dsd" className="me-3" />
                  </div>
                  {t('howworks')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default LanddingPage;

/**                    <div className="my-4" style={{position:"relative"}}>
                        <div className="text-about-dis-box">
                            <p style={{  fontFamily: 'White Dream PERSONAL USE ONLY'}}>Espagne</p>
                        </div>
                        <img src={espagne} alt="image" style={{width:"100%",height:"304px"}} />
                    </div>
                     */
